<template>
  <v-app>
    <!-- Logo Section -->
    <div id="app-logo">
      <img src="assets/images/logo.png" alt="logo" />
    </div>


    <!-- Border Line Below Logo -->
    <div id="border"></div>

    <!-- Main Content -->
    <v-main>
      <v-container fluid id="main-container" class="pa-0">
        <router-view></router-view>
      </v-container>
    </v-main>

    <!-- Footer -->
    <v-footer id="footer" class="mt-0">
      <v-spacer></v-spacer>
      <div class="footer-text">
        Diners Club Online Card Application || {{ new Date().getFullYear() }}
      </div>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
/* Logo Styling */
#app-logo {
  position: absolute;
  top: 10px;
  left: 4%;
  width: 150px;
  height: auto;
  max-width: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* Border Below Logo */
#border {
  border-top: 3px solid #000;
  margin-top: 80px;
  margin-bottom: 0px; /* Add margin to create space below */
}

/* Main Container Styling */
#main-container {
  padding-top: 20px;
  margin-bottom: 0;
}

/* Footer Styling */
#footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: #000;
  color: white;
  text-align: right;
  padding: 10px;
}

.footer-text {
  padding: 0 16px;
}

/* Responsive Adjustments */
@media (max-width: 768px) {
  #app-logo {
    width: 120px;
    top: 15px;
    left: 5%;
  }

  #border {
    margin-top: 100px; /* Adjust to prevent overlap */
    margin-bottom: 15px;
  }

  #main-container {
    padding-top: 15px;
  }

  #footer {
    padding: 8px;
    margin-top: auto;
  }
}

@media (max-width: 480px) {
  #app-logo {
    width: 100px;
    top: 20px;
    left: 10%;
  }

  #border {
    margin-top: 120px; /* Further increase margin to prevent overlap on small screens */
    margin-bottom: 10px;
  }

  #main-container {
    padding-top: 10px;
  }

  #footer {
    padding: 6px;
    margin-top: 20;
  }
}
</style>
